var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.router && _vm.router.name)?_c('router-link',{class:_vm.isActive(),attrs:{"tag":"li","to":_vm.router}},[_c('a',{attrs:{"href":"#"}},[_c('span',[_vm._v(_vm._s(_vm.name))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }